var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.go.apply(null, arguments)}}},[_vm._v("Gestión institucional")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }